import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-tommi',
  templateUrl: './tommi.component.html',
  styleUrls: ['./tommi.component.scss']
})
export class TommiComponent implements OnInit {

  exposition: CardContent = {
    title: 'TOMMI',
    subtitle: 'Budget impact model for multiple myeloma treatment options',
    image_source: 'assets/images/PathwayExplorer.PNG',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Clients, Partners</h4>Pharmametrics, BMS',
      '<h4>Methods</h4>Interactive pathway exploration and visualisation',
      '<h4>Technology / Skills</h4>Javascript, Bootstrap, D3',
      '<h4>Term</h4>2019',
    ]
  };


  constructor() { }

  ngOnInit(): void {
  }

}
